import { useEffect, useState } from 'react';
import { CustomModal } from '../CustomModal';
import { Btn } from '../ui';

interface ArchiveServiceCenterModalProps {
    serviceCenter: { id: string; name?: string | null } | null;
    isArchiving: boolean;
    onDismiss: () => void;
    onConfirmArchive: () => void;
}

export const ArchiveServiceCenterModal = ({
    serviceCenter,
    isArchiving,
    onDismiss,
    onConfirmArchive,
}: ArchiveServiceCenterModalProps) => {
    const visible = Boolean(serviceCenter?.id);
    const [confirmReady, setConfirmReady] = useState(false);

    useEffect(() => {
        if (!visible) {
            setConfirmReady(false);
            return;
        }
        setConfirmReady(false);
        const timer = window.setTimeout(() => setConfirmReady(true), 400);
        return () => window.clearTimeout(timer);
    }, [visible, serviceCenter?.id]);

    const serviceCenterName = serviceCenter?.name?.trim() || 'this service center';

    return (
        <CustomModal
            onDismiss={onDismiss}
            visible={visible}
            header="Archive service center?"
            footer={
                <div className="modal-footer-actions">
                    <Btn
                        variant="secondary-outlined"
                        buttonText="Cancel"
                        buttonDisabled={isArchiving}
                        buttonOnClick={onDismiss}
                    />
                    <Btn
                        variant="danger"
                        buttonText={isArchiving ? 'Archiving...' : 'Archive'}
                        buttonDisabled={isArchiving || !confirmReady}
                        buttonOnClick={onConfirmArchive}
                    />
                </div>
            }
        >
            <p>
                You are about to archive <strong>“{serviceCenterName}”</strong>. It will be hidden from the
                service center list.
            </p>
            <p>Equipment already assigned to this service center keeps that assignment until you choose another one.</p>
        </CustomModal>
    );
};
